<db-dialog-wrapper [dialog]="this" [width]="'848px'"[canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading" [fullScreen]="isMobile">
  <div class="db-enable-https db-enable-https-sm">
    <div class="db-enable-https-dialog__message">
      <div>
        <div class="db-enable-https-title">{{'text_enableHttps.title' | dbText}}</div>
        <div class="db-enable-https-desc" [innerHTML]="'text_enableHttps.desc' | dbText"></div>
        <div class="db-enable-https-sub-title">{{'text_enableHttps.subTitle' | dbText}}</div>
        <div dbCustomScrollbar class="db-scroll">
          <form class="db-check_type" [formGroup]="generateFreeCertificateForm" [ngClass]="{'db-item1': allDomains.length === 1}">
            <ng-container *ngFor="let domain of allDomains; let i = index">
              <div [ngClass]="{'db-disabled': (domain.pointed === 0 && domain.server !== 'cloudflare') }">
                <label class="db-domains">
                  <div>
                <span class="db-fc-checkbox">
                  <input type="radio" (click)="addClass($event)" id="generateHttps_{{i}}" value="{{domain.id}}" name="generateHttps">
                  <span><i class="db-icon db-icon-circle-sm"></i></span>
                </span>
                    <div>
                      <p class="db-small">Domain</p>
                      <div class="db-domain-name">
                        <span class="db-pointed"></span>  <span>{{domain.name}} <i *ngIf="(domain.pointed === 0 && domain.server !== 'cloudflare')" class="db-icon db-icon-info-lined" dbInfoTooltipHover  [dbInfoTooltipHoverPosition]="'bottom-left'" [dbInfoTooltipHoverHeader]="'Domain Is Not Pointed.'" [dbInfoTooltipHoverBody]="'<a href='+ helpCenter +' rel=\'noopener\' target=\'_blank\'><span>How to point your domain to 10Web</span><i class=\'db-icon db-icon-arrow-down-big\'></i></a>'"></i></span>
                      </div>
                    </div>

                  </div>
                </label>
              </div>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
    <div class="db-server-error" *ngIf="serverErrors && serverErrors.message">{{serverErrors.message}}</div>
    <div class="db-enable-https-dialog__buttons">
      <a class="db-button" (click)="cancel()"  [ngClass]="{'db-button_disabled': loading}" ><span>{{'text_cancel' | dbText}}</span></a>
      <a class="db-button db-button_info"  [ngClass]="{'db-button_disabled': loading || !domainNameIds || (domainNameIds && domainNameIds.length === 0)}" (click)="generateFreeCertificate()">
        <span>{{'text_apply' | dbText}}</span>
      </a>
    </div>

    <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
  </div>
</db-dialog-wrapper>
